import { Module } from 'vuex';
import { IVisaSubtype } from '@/shared/model/travelpurpose/visa-subtype.model';
import { setLocalStorage, getLocalStorage } from '@/shared/utils/utils';
import { MetaInfo } from '@/shared/model/meta-info.model';

export const tlsStore: Module<any, any> = {
  state: {
    client: '',
    issuer: '',
    userType: '',
    formId: '',
    formGroupId: '',
    residenceCountryCode: '',
    visa: <IVisaSubtype>{},
    error: '',
    metaInfo: <MetaInfo>{},
    workflowVariants: '',
    workflow: ''
  },
  getters: {
    client: state => state.client,
    issuer: state => state.issuer,
    userType: state => {
      const userType = state.userType || getLocalStorage('userType');
      return userType;
    },
    formId: state => state.formId,
    formGroupId: state => state.formGroupId,
    residenceCountryCode: state => state.residenceCountryCode,
    error: state => state.error,
    visa: state => state.visa,
    metaInfo: state => state.metaInfo,
    workflowVariants: state => state.workflowVariants,
    workflow: state => state.workflow
  },
  mutations: {
    client(state, newClient) {
      state.client = newClient;
      setLocalStorage('client', newClient);
    },
    issuer(state, newIssuer) {
      state.issuer = newIssuer;
      setLocalStorage('issuer', newIssuer);
      setLocalStorage('residenceCountryCode', newIssuer.substr(0, 2));
    },
    userType(state, newUserType) {
      state.userType = newUserType;
      setLocalStorage('userType', newUserType);
    },
    formGroupId(state, newFormGroupId) {
      state.formGroupId = newFormGroupId;
      setLocalStorage('formGroupId', newFormGroupId);
    },
    formId(state, newFormId) {
      state.formId = newFormId;
      setLocalStorage('formId', newFormId);
    },
    error(state, newError) {
      state.error = newError;
      setLocalStorage('error', newError);
    },
    residenceCountryCode(state, newResidenceCountryCode) {
      state.residenceCountryCode = newResidenceCountryCode;
      setLocalStorage('residenceCountryCode', newResidenceCountryCode);
    },
    visa(state, newVisa: IVisaSubtype) {
      state.visa = newVisa;
      setLocalStorage('visa', JSON.stringify(newVisa));
    },
    metaInfo(state, metaInfo) {
      state.metaInfo = metaInfo;
    },
    workflowVariants(state, workflowVariants) {
      state.workflowVariants = workflowVariants;
    },
    workflow(state, workflow) {
      state.workflow = workflow;
    }
  }
};
